export default __webpack_public_path__ + "static/media/Class-9-10-CBSE-SocialScience.38fed3e8.pdf";